import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import { Provider } from 'react-redux'
import { ModalProvider } from 'react-modal-hook'
import { I18nextProvider } from 'react-i18next'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persister } from './store'
// import i18n from './i18n'

import { ToastContainer } from 'react-toastify'
import 'custom/styles/color_variable.css'
import 'custom/styles/image.css'
import 'antd/dist/antd.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import './styles/typography.css'
import './styles/utilities.css'
import './styles/buttons.css'
import './styles/colors.css'
import './styles/inputs.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './index.css'

import App from './App'
import i18n from './i18n'

Modal.setAppElement('#root')

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <ModalProvider>
          <div className='h-100'>
            <Suspense fallback='loading'>
              <App />
            </Suspense>
          </div>
        </ModalProvider>
      </PersistGate>
    </Provider>
  </I18nextProvider>,
  //error message handle framework changes
  // <I18nextProvider i18n={i18n}>
  // <Provider store={store}>
  //   <PersistGate loading={null} persister={persister}>
  //     <ModalProvider>
  //       <div className='h-100'>
  //         <Suspense fallback='loading'>
  //           <App />
  //           <ToastContainer
  //             closeOnClick
  //             className='toast-container'
  //             progressClassName='progress-toast'
  //           />
  //         </Suspense>
  //       </div>
  //     </ModalProvider>
  //   </PersistGate>
  // </Provider>
  //   </I18nextProvider>
  document.getElementById('root'),
)
